export default __webpack_public_path__ + "static/media/placeholder_business05-fr-web.e2a232e4.png";